'use client';
import React from 'react';
import { useModel } from '@/context/ModelContext';
import { fmtCrShort, fmtNum, fmtPct } from '@/lib/financial-model';

export default function DerivedOutputsPanel() {
  const { model } = useModel();
  const a = model?.assumptions;

  const derived = [
    {
      label: 'Design Annual Capacity',
      value: `${fmtNum(model?.designCapacity)} Tonnes`,
      note: `${a?.tphCapacity} × ${a?.operatingHoursPerDay}h × ${a?.operatingDaysPerYear} days`,
    },
    {
      label: 'Total Variable Cost / Tonne',
      value: `₹${fmtNum(model?.totalVariableCostPerTonne)}`,
      note: 'RM + Power + Labour + Maint + Pack + Other',
    },
    {
      label: 'Total Fixed Cost (Base)',
      value: fmtCrShort(model?.totalFixedCostBase),
      note: 'Lease + Salaries + Insurance',
    },
    {
      label: 'Total Project Cost',
      value: fmtCrShort(model?.totalProjectCost),
      note: 'CAPEX + Working Capital',
    },
    {
      label: 'Depreciation Base',
      value: fmtCrShort(model?.depreciationBase),
      note: 'Machinery + Civil + Electrical',
    },
    {
      label: 'Annual Depreciation',
      value: fmtCrShort(model?.annualDepreciation),
      note: `SLM over ${a?.depreciationPeriod} years`,
    },
    {
      label: 'Annual Debt Service',
      value: `₹${fmtNum(Math.abs(model?.annualDebtService))}`,
      note: `PMT(${(a?.interestRate * 100)?.toFixed(1)}%, ${a?.loanTenure - a?.moratorium} yrs, ₹${fmtNum(a?.debtAmount)})`,
    },
    { label: 'Project IRR', value: fmtPct(model?.projectIRR), note: '10-year unlevered' },
    { label: 'Equity IRR', value: fmtPct(model?.equityIRR), note: '10-year levered' },
    {
      label: 'NPV @ WACC',
      value: fmtCrShort(model?.projectNPV),
      note: `Discount rate ${(a?.discountRate * 100)?.toFixed(1)}%`,
    },
  ];

  return (
    <div className="bg-success-bg border border-green-200 rounded-xl p-4">
      <p className="text-xs font-semibold text-primary uppercase tracking-wider mb-3">
        Derived / Calculated Outputs (auto-updated)
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {derived?.map((d) => (
          <div
            key={`derived-${d?.label}`}
            className="bg-card rounded-lg p-2.5 border border-green-100"
          >
            <p className="text-xs text-muted-foreground leading-tight mb-1">{d?.label}</p>
            <p className="font-mono text-sm font-bold text-primary">{d?.value}</p>
            <p className="text-xs text-muted-foreground mt-0.5 leading-tight">{d?.note}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
